/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

interface IProps {
  handleDelete: (id: any) => void;
  onClose: () => void;
  selectedRow: any;
  /**
   * CHANGE: widened from `string` to `ReactNode` so a caller can emphasise the
   * item being deleted — naming it in bold is what stops someone confirming a
   * delete for the wrong row. Every existing string caller is unaffected.
   */
  message?: React.ReactNode;
  children?: React.ReactNode;
}

const DeletePopup = ({ handleDelete, onClose, selectedRow, message, children }: IProps) => {
  return (
    <div className="relative bg-white dark:bg-gray-800">
      <div className="p-4 md:p-5 text-center">
        <svg
          className="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 20 20"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
        {children && <div className="mb-4">{children}</div>}
        <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400 ">
          {message || "Are you sure you want to delete this Data?"}
        </h3>

        {/* Corrected wrapper: Changed justify-between to justify-center and added gap-4 here */}
        <div className="mt-6 flex items-center justify-center gap-4">
          <button
            type="button"
            className="h-11 px-5 text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 rounded-lg inline-flex items-center justify-center"
            onClick={() => handleDelete(selectedRow.id)}
          >
            Yes, I'm sure
          </button>

          <button
            type="button"
            className="h-11 px-5 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-4 focus:ring-gray-100 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:text-white"
            onClick={onClose}
          >
            No, cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletePopup;